import { Routes } from '@angular/router';

import { GameShowSettingsResolver } from '../gameshow/resolvers/gameshow-settings.resolver';
import { TEACHER_ROUTE } from '../routing-constants/teacher-routing.constant';

export const GAME_SHOW_ROUTE = {
  name: ':classId/game-show',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'game-show'];
  },
  DEFAULT: '',

  WAITING_ROOM: {
    name: 'waiting-room/:activityId',
    route(classId: string, activityId: string): string[] {
      return [...GAME_SHOW_ROUTE.route(classId), 'waiting-room', activityId];
    }
  },
  GAMEPLAY: {
    name: 'gameplay/:activityId',
    route(classId: string, activityId: string): string[] {
      return [...GAME_SHOW_ROUTE.route(classId), 'gameplay', activityId];
    }
  },
  SURVEY: {
    name: 'survey/:activityId',
    route(classId: string, activityId: string): string[] {
      return [...GAME_SHOW_ROUTE.route(classId), 'survey', activityId];
    }
  },
  SETTINGS: {
    name: 'settings/:publicUnitId',
    route(classId: string, publicUnitId: string): string[] {
      return [...GAME_SHOW_ROUTE.route(classId), 'settings', publicUnitId];
    }
  },
  SETTINGS_LINKED: {
    name: 'settings/:publicUnitId/:baseActivityId',
    route(classId: string, publicUnitId: string, baseActivityId: string): string[] {
      return [...GAME_SHOW_ROUTE.route(classId), 'settings', publicUnitId, baseActivityId];
    }
  }
};

export const GAME_SHOW_ROUTES: Routes = [
  {
    path: GAME_SHOW_ROUTE.WAITING_ROOM.name,
    loadComponent: () => import('app/teacher/game-show/gameshow-waiting-room/game-show-waiting-room.component')
      .then((m) => m.GameShowWaitingRoomComponent)
  },
  {
    path: GAME_SHOW_ROUTE.SETTINGS.name,
    loadComponent: () => import('app/teacher/game-show/game-show-teacher-settings/game-show-teacher-settings.component')
      .then((m) => m.GameShowTeacherSettingsComponent),
    resolve: { gameShowRunSettings: GameShowSettingsResolver }
  },
  {
    path: GAME_SHOW_ROUTE.SETTINGS_LINKED.name,
    loadComponent: () => import('app/teacher/game-show/game-show-teacher-settings/game-show-teacher-settings.component')
      .then((m) => m.GameShowTeacherSettingsComponent),
    resolve: { gameShowRunSettings: GameShowSettingsResolver }
  },
  {
    path: GAME_SHOW_ROUTE.GAMEPLAY.name,
    loadComponent: () => import('app/teacher/game-show/game-show-teacher-gameplay/game-show-teacher-gameplay.component')
      .then((m) => m.GameShowTeacherGameplayComponent)
  },
  {
    path: GAME_SHOW_ROUTE.SURVEY.name,
    loadComponent: () => import('app/teacher/game-show/game-show-teacher-feedback-survey/game-show-teacher-feedback-survey.component')
      .then((m) => m.GameShowTeacherFeedbackSurveyComponent)
  }
];
